import * as Sentry from '@sentry/react';

import { API_ENDPOINT, ENVIRONMENT } from './sharedModules/utils/env';

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  const isProduction = ENVIRONMENT === 'production';

  Sentry.init({
    dsn,
    environment: ENVIRONMENT,
    // dataCollection omitted on purpose: SDK default (userInfo: false, no bodies)
    // keeps customer/vendor PII out of Sentry. sendDefaultPii is the opt-in if ever needed.
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: isProduction ? 0.2 : 1.0,
    tracePropagationTargets: ['localhost', API_ENDPOINT],
    replaysSessionSampleRate: isProduction ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
